import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
/**
 * 微前端语言管理Hook - 通过props获取语言
 * @param namespace 翻译命名空间
 * @param locale 语言参数（从props传入）
 * @returns 翻译函数和当前语言
 */
export const useLocale = (namespace, locale) => {
    const { t, i18n: i18nInstance } = useTranslation(namespace);
    const [currentLocale, setCurrentLocale] = useState("vi");
    // 当locale props变化时，自动切换语言
    useEffect(() => {
        if (locale && locale !== currentLocale) {
            setCurrentLocale(locale);
            // 当语言变化时，自动切换i18n语言
            if (locale !== i18nInstance.language) {
                i18n.changeLanguage(locale);
            }
        }
    }, [locale, currentLocale, i18nInstance.language]);
    return {
        t,
        currentLanguage: currentLocale,
        changeLanguage: i18n.changeLanguage,
    };
};
